import {OrderProductModel} from "../Models/OrderModel";
import {useGetReductionFromQuantity} from "./useGetReductionFromQuantity";

export const useUpdateOrderWithQuantityDiscount = (): (p: OrderProductModel, quantity: number, otherOrderProducts: OrderProductModel[]) => OrderProductModel => {
    const [getTotalMinusReduction, getReduction] = useGetReductionFromQuantity()


    return (p: OrderProductModel, quantity: number, otherOrderProducts: OrderProductModel[]): OrderProductModel => {
        const unitPriceTTC = p.unitPriceTTC || 0
        const unitDepositPriceTTC = p.unitDepositPriceTTC || 0
        const unitPriceHT = p.unitPriceHT || 0
        const discount = p. discountModel ? getReduction(unitPriceTTC * quantity, unitPriceTTC, quantity, p.discountModel, otherOrderProducts) : 0
        const totalPriceHT = p.discountModel ? +(getTotalMinusReduction(unitPriceHT * quantity, unitPriceTTC, quantity, p.discountModel, otherOrderProducts).toFixed(5)) + (unitDepositPriceTTC * quantity) : 0
        const totalPriceTTC = p.discountModel ? +(getTotalMinusReduction((unitPriceTTC - unitDepositPriceTTC)* quantity, unitPriceTTC, quantity, p.discountModel, otherOrderProducts) + (unitDepositPriceTTC * quantity)).toFixed(2) : 0
        const totalDepositPriceTTC = p.unitDepositPriceTTC ? p.unitDepositPriceTTC * quantity : 0
        return {
            ...p,
            quantity,
            discount,
            totalPriceHT,
            totalPriceTTC,
            totalDepositPriceTTC,
            totalTva: totalPriceTTC - totalPriceHT
        }
    }
}
